import Cookies from 'js-cookie';
import { getBaseUrl } from '../utils/apiHelper';

const API_URL = `${getBaseUrl()}/api/associations`;

const associationService = {
    createAssociations: async (dryRun = false) => {
        try {
            console.log("🔄 Creating email-invoice associations...");
            const token = Cookies.get("token");
            const response = await fetch(`${API_URL}/create-associations${dryRun ? '?dryRun=true' : ''}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });

            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.message || "Failed to create associations.");
            }

            console.log("✅ Associations created successfully:", data);
            return data;
        } catch (error) {
            console.error("❌ Error creating associations:", error.message);
            throw error;
        }
    },

    associateEmailWithInvoice: async (emailId, invoiceId) => {
        try {
            console.log(`🔄 Associating email ${emailId} with invoice ${invoiceId}...`);
            const token = Cookies.get("token");
            const response = await fetch(`${API_URL}/associate`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ emailId, invoiceId }),
            });

            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.message || "Failed to associate email with invoice.");
            }

            console.log("✅ Email associated with invoice successfully:", data);
            return data;
        } catch (error) {
            console.error("❌ Error associating email with invoice:", error.message);
            throw error;
        }
    },

    getUnassociatedInvoices: async () => {
        try {
            console.log("🔄 Fetching unassociated invoices...");
            const token = Cookies.get("token");
            const response = await fetch(`${API_URL}/unassociated-invoices`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.message || "Failed to fetch unassociated invoices.");
            }

            console.log("✅ Unassociated invoices fetched successfully:", data.invoices);
            return data.invoices;
        } catch (error) {
            console.error("❌ Error fetching unassociated invoices:", error.message);
            throw error;
        }
    },

    getUnassociatedEmails: async () => {
        try {
            console.log("🔄 Fetching unassociated emails...");
            const token = Cookies.get("token");
            const response = await fetch(`${API_URL}/unassociated-emails`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.message || "Failed to fetch unassociated emails.");
            }

            console.log("✅ Unassociated emails fetched successfully:", data.emails);
            return data.emails;
        } catch (error) {
            console.error("❌ Error fetching unassociated emails:", error.message);
            throw error;
        }
    },

    /**
     * Fetch the associated email for a given invoice
     */
    getAssociatedEmailForInvoice: async (invoiceId) => {
        try {
            const token = Cookies.get("token");
            const response = await fetch(`${API_URL}/invoice/${invoiceId}/email`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });
            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.message || "Failed to fetch associated email.");
            }
            return data.email;
        } catch (error) {
            console.error("❌ Error fetching associated email:", error.message);
            throw error;
        }
    }
};

export default associationService;